const Payment = require('@/lib/Payments/Payment');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

/**
 * @param $scope
 * @param {AppConfig} appConfig
 * @param {CartService} cartService
 * @param {PaymentMethodService} paymentMethodService
 * @param {ToastFactory} toastFactory
 * @param {UserService} userService
 */
const PayPalHereCtrl = function PayPalHereCtrl(
    $scope,
    appConfig,
    cartService,
    paymentMethodService,
    toastFactory,
    userService
) {
    $scope.paymentMethodScopes[PaymentMethodRef.CARD_PAYPAL_HERE] = $scope;

    $scope.thisPaymentMethodRef = PaymentMethodRef.CARD_PAYPAL_HERE;
    $scope.thisPaymentMethod = paymentMethodService.getByRef($scope.thisPaymentMethodRef);

    $scope.cart = cartService;

    $scope.partialAmount = null;
    $scope.getAmount = function getAmount() {
        if ($scope.partialAmount !== null) {
            return $scope.partialAmount;
        }

        return $scope.cart.getRemainingBalance();
    };

    $scope.clearPartialPayment = function clearPartialPayment() {
        $scope.partialAmount = null;
    };

    $scope.makePartialPayment = function makePartialPayment() {
        $scope.showPartialPaymentModal('make', function (amount) {
            if (amount) {
                $scope.partialAmount = amount;
            } else {
                $scope.partialAmount = null;
            }
        });
    };

    $scope.lastAmountOpened = null;

    let getPayPalHereUrl = function getPayPalHereUrl() {
        /**
         * As the PayPal Here API is pretty bad when it comes to
         * specifying line totals, discounts, etc, we'll just add
         * a single amalgamated item that represents the whole order.
         */
        let invoice = {};

        let amount = $scope.getAmount();
        $scope.lastAmountOpened = amount;

        invoice.itemList = {
            item: [
                {
                    taxRate: '0',
                    name: 'DigiPoint Purchase',
                    description: 'DigiPoint Purchase',
                    unitPrice: amount,
                    taxName: 'Tax',
                    quantity: '1',
                },
            ],

        };
        invoice.paymentTerms = 'DueOnReceipt';
        invoice.currencyCode = userService.company.currency.code;
        invoice.discountPercent = '0';
        // invoice['merchantEmail'] = 'tmesserschmidt@paypal.com';
        // invoice['payerEmail'] = 'foo@bar.com';

        console.debug('PayPal Here Amount', amount);
        console.debug('PayPal Here Invoice', invoice);

        let returnUrl = appConfig.appUrl + '/paypalhere/callback';
        let retUrl = encodeURIComponent(returnUrl + '?Type={Type}&InvoiceId={InvoiceId}&Tip={Tip}&Email={Email}&TxId={TxId}');
        let ppHereUrl = 'paypalhere://takePayment?returnUrl=' + retUrl;

        ppHereUrl += '&accepted=card,paypal';
        ppHereUrl += '&step=choosePayment';
        ppHereUrl = ppHereUrl + '&invoice=' + encodeURIComponent(JSON.stringify(invoice));

        return ppHereUrl;
    };

    $scope.openPayPalHere = function openPayPalHere() {
        if ($scope.getAmount() > $scope.cart.getRemainingMaxPayment()) {
            toastFactory.warningTop(
                null,
                {
                    key: 'PAYMENT.MAX_AMOUNT_ALERT',
                    params: { max: $scope.cart.getRemainingMaxPayment() },
                }
            );
            return;
        }

        let url = getPayPalHereUrl();
        window.open(url);
    };

    $scope.$on('payment-modal.ok-pressed', function (event, paymentMethodRef) {
        if (paymentMethodRef === $scope.thisPaymentMethodRef) {
            if ($scope.lastAmountOpened === null) {
                toastFactory.warningTop('PAYMENT.PAYPAL_NOT_OPENED');
                $scope.preventClose();
                return;
            }

            let payment = new Payment();
            payment.setPaymentMethod($scope.thisPaymentMethod);
            payment.setTendered($scope.lastAmountOpened);
            payment.setThirdPartyID($scope.cart.generatePaymentThirdPartyID());
            $scope.addPayment(payment);

            // Clear for next use.
            $scope.partialAmount = null;
        }
    });
};

module.exports = PayPalHereCtrl;
